// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
  display: block;
}

.logo {
  position: absolute;
  bottom: 1%;
  height: 10vh;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.modal_container {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 100; /* Sit on top */
  padding-top: 50vh; /* Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.modal-content {
  background-color: rgba(254, 254, 254, 0);
  margin: auto;
  padding: 20px;
  width: 50%;
  text-align: center;
  user-select: none;
}

/* .modal-close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.modal-close:hover,
.modal-close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
} */
.loader {
  width: 100%;
  height: 15px;
  text-align: center;
}

.dot {
  position: relative;
  width: 15px;
  height: 15px;
  margin: 0 2px;
  display: inline-block;
}

.dot:first-child:before {
  animation-delay: 0ms;
}

.dot:first-child:after {
  animation-delay: 0ms;
}

.dot:last-child:before {
  animation-delay: 200ms;
}

.dot:last-child:after {
  animation-delay: 200ms;
}

.dot:before {
  content: "";
  position: absolute;
  left: 0;
  width: 15px;
  height: 15px;
  background-color: blue;
  animation-name: dotHover;
  animation-duration: 900ms;
  animation-timing-function: cubic-bezier(0.82, 0, 0.26, 1);
  animation-iteration-count: infinite;
  animation-delay: 100ms;
  background: white;
  border-radius: 100%;
}

.dot:after {
  content: "";
  position: absolute;
  z-index: -1;
  background: black;
  box-shadow: 0px 0px 1px black;
  opacity: 0.2;
  width: 100%;
  height: 3px;
  left: 0;
  bottom: -2px;
  border-radius: 100%;
  animation-name: dotShadow;
  animation-duration: 900ms;
  animation-timing-function: cubic-bezier(0.82, 0, 0.26, 1);
  animation-iteration-count: infinite;
  animation-delay: 100ms;
}

@keyframes dotShadow {
  0% {
    transform: scaleX(1);
  }
  50% {
    opacity: 0;
    transform: scaleX(0.6);
  }
  100% {
    transform: scaleX(1);
  }
}
@keyframes dotHover {
  0% {
    top: 0px;
  }
  50% {
    top: -50px;
    transform: scale(1.1);
  }
  100% {
    top: 0;
  }
}
.dg {
  padding: 3%;
  position: absolute;
  font-size: large;
}

/* Hide settings */
.dg .main {
  display: block;
}

.dg .cr.boolean,
.dg .cr.string,
.dg .cr.function,
.dg.ac .close-button.close-bottom {
  background-color: rgba(170, 170, 170, 0.1333333333);
  border-left: 0px;
  border-bottom: 0px;
}

.dg .cr.string input:hover {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid white;
  border-radius: 4px;
}

.dg .cr.string input:focus {
  background-color: rgba(0, 0, 0, 0);
}

.dg .cr.string input {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid rgba(255, 255, 255, 0.1333333333);
  border-radius: 4px;
}

.dg .close-button {
  display: none;
}

.custom-prompt-gui {
  position: absolute;
  bottom: 25%;
  left: 35%;
  float: none;
  top: unset;
}

.prompt {
  position: fixed;
  bottom: 25%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.prompt-input, textarea {
  background-color: rgba(255, 255, 255, 0.2666666667);
  font-size: 5em;
  border-radius: 0.25em;
  outline: none;
  border: 2px solid rgba(170, 170, 170, 0.6);
  text-align: center;
  backdrop-filter: blur(2px);
  width: 70vw;
}

/* :root {
  --tp-font-family: Courier;
} */
:root {
  --tp-blade-value-width: 55vw;
}

:root {
  --tp-base-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  --tp-container-foreground-color: #fff;
  --tp-label-foreground-color: #fff;
  --tp-container-unit-size: 28px;
  --tp-button-background-color: rgba(0,0,0, .3);
  --tp-button-foreground-color: #fff;
  --tp-input-background-color: rgba(0,0,0, .3);
  --tp-input-foreground-color: #fff;
  --tp-button-background-color-active: rgba(0,0,0, .3);
  --tp-button-background-color-focus: rgba(0,0,0, .3);
  --tp-button-background-color-hover: rgba(0,0,0, .3) ;
  --tp-base-background-color: rgb(40 41 46 / .6);
  --tp-container-background-color: rgba(187, 188, 196, 0.1);
}

[data-theme=light] {
  --tp-container-foreground-color: #000;
  --tp-label-foreground-color: #000;
  --tp-button-background-color: rgba(165,165,165, .3);
  --tp-button-foreground-color: #000;
  --tp-input-background-color: rgba(255,255,255, .3);
  --tp-input-foreground-color: #000;
  --tp-button-background-color-active: rgba(255,255,255, .3);
  --tp-button-background-color-focus: rgba(255,255,255, .3);
  --tp-button-background-color-hover: rgba(255,255,255, .3) ;
  --tp-base-background-color: rgba(249, 249, 249, 0.6);
  --tp-container-background-color: rgba(65, 65, 65, 0.1);
}

[data-theme=dark] {
  --tp-container-foreground-color: #fff;
  --tp-label-foreground-color: #fff;
  --tp-button-background-color: rgba(0,0,0, .3);
  --tp-button-foreground-color: #fff;
  --tp-input-background-color: rgba(0,0,0, .3);
  --tp-input-foreground-color: #fff;
  --tp-button-background-color-active: rgba(0,0,0, .3);
  --tp-button-background-color-focus: rgba(0,0,0, .3);
  --tp-button-background-color-hover: rgba(0,0,0, .3) ;
  --tp-base-background-color: rgb(40 41 46 / .6);
  --tp-container-background-color: rgb(32 32 32 / 20%);
}

div.tp-dfwv {
  width: 90vw;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
}
@supports (-webkit-touch-callout: none) {
  div.tp-dfwv {
    /* CSS specific to iOS devices */
    position: fixed;
  }
}
@supports not (-webkit-touch-callout: none) {
  div.tp-dfwv {
    /* CSS for other than iOS devices */
    position: absolute;
  }
}

div.tp-tabv_c {
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(40, 40, 40, 0.5) rgba(40, 41, 46, 0.1);
  max-height: 20vh;
}

div.tp-tabv_c::-webkit-scrollbar {
  width: 12px; /* width of the entire scrollbar */
}

div.tp-tabv_c::-webkit-scrollbar-track {
  background: rgba(40, 41, 46, 0.1); /* color of the tracking area */
}

div.tp-tabv_c::-webkit-scrollbar-thumb {
  background-color: rgba(40, 40, 40, 0.5); /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid rgba(40, 41, 46, 0.1); /* creates padding around scroll thumb */
}

div.tp-rotv {
  font-size: 1em;
  backdrop-filter: blur(4px);
}

div.tp-btngridv {
  display: inline-grid;
  gap: 0.5em;
  justify-self: center;
}

div.tp-fldv_m {
  display: none;
}

div.btn-icon-style {
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* div.tp-btnv_t {
  font-weight: normal;
  font-family: "Font Awesome 6 Free Solid";
} */
/* div.tp-btnv {
  width: 25%;
} */`, "",{"version":3,"sources":["webpack://./t2m-playground/src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,YAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAEF;;AAAA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,oBAAA;AAGD;;AAAA;EACE,aAAA,EAAA,sBAAA;EACA,eAAA,EAAA,kBAAA;EACA,YAAA,EAAA,eAAA;EACA,iBAAA,EAAA,wBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA,EAAA,eAAA;EACA,aAAA,EAAA,gBAAA;EACA,cAAA,EAAA,4BAAA;EACA,8BAAA,EAAA,mBAAA;EACA,oCAAA,EAAA,qBAAA;AAGF;;AADA;EACE,wCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAIF;;AAFA;;;;;;;;;;;;GAAA;AAcA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AAIF;;AADA;EACE,oBAAA;AAIF;;AADA;EACE,oBAAA;AAIF;;AADA;EACE,sBAAA;AAIF;;AADA;EACE,sBAAA;AAIF;;AADA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yDAAA;EACA,mCAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AAIF;;AADA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,mCAAA;EACA,sBAAA;AAIF;;AADA;EACE;IACE,oBAAA;EAIF;EAFA;IACE,UAAA;IACA,sBAAA;EAIF;EAFA;IACE,oBAAA;EAIF;AACF;AADA;EACE;IACE,QAAA;EAGF;EADA;IACE,UAAA;IACA,qBAAA;EAGF;EADA;IACE,MAAA;EAGF;AACF;AAAA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AACA,kBAAA;AACA;EACE,cAAA;AAEF;;AACA;;;;EAKE,mDAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AACA;EACE,kCAAA;EACA,uBAAA;EACA,kBAAA;AAEF;;AAAA;EACE,kCAAA;AAGF;;AADA;EACE,kCAAA;EACA,mDAAA;EACA,kBAAA;AAIF;;AADA;EACE,aAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAIF;;AADA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAIF;;AADA;EACE,mDAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;AAIF;;AADA;;GAAA;AAIA;EACE,4BAAA;AAGF;;AAAA;EACE,iHAAA;EACA,qCAAA;EACA,iCAAA;EACA,8BAAA;EACA,6CAAA;EACA,kCAAA;EACA,4CAAA;EACA,iCAAA;EACA,oDAAA;EACA,mDAAA;EACA,oDAAA;EACA,8CAAA;EACA,yDAAA;AAGF;;AAAA;EACE,qCAAA;EACA,iCAAA;EACA,mDAAA;EACA,kCAAA;EACA,kDAAA;EACA,iCAAA;EACA,0DAAA;EACA,yDAAA;EACA,0DAAA;EACA,oDAAA;EACA,sDAAA;AAGF;;AAAA;EACE,qCAAA;EACA,iCAAA;EACA,6CAAA;EACA,kCAAA;EACA,4CAAA;EACA,iCAAA;EACA,oDAAA;EACA,mDAAA;EACA,oDAAA;EACA,8CAAA;EACA,oDAAA;AAGF;;AAAA;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;AAGF;AADE;EANF;IAOM,gCAAA;IACA,eAAA;EAIJ;AACF;AAFI;EAXJ;IAYM,mCAAA;IACA,kBAAA;EAKJ;AACF;;AAFA;EACE,cAAA;EACA,qBAAA;EACA,4DAAA;EACA,gBAAA;AAKF;;AAHA;EACE,WAAA,EAAA,kCAAA;AAMF;;AAHA;EACE,iCAAA,EAAA,+BAAA;AAMF;;AAHA;EACE,uCAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,kCAAA;EACA,uCAAA,EAAA,wCAAA;AAMF;;AAHA;EACE,cAAA;EACA,0BAAA;AAMF;;AAHA;EACE,oBAAA;EACA,UAAA;EACA,oBAAA;AAMF;;AAHA;EACE,aAAA;AAMF;;AAHA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAMF;;AACA;;;GAAA;AAKA;;GAAA","sourcesContent":["html, body {\n  margin: 0;\n  height: 100%;\n}\n#app {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n.logo {\n position: absolute;\n bottom: 1%;\n height: 10vh;\n left: 50%;\n transform: translate(-50%, -50%);\n pointer-events: none;\n}\n\n.modal_container {\n  display: none; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 100; /* Sit on top */\n  padding-top: 50vh; /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100vw; /* Full width */\n  height: 100vh; /* Full height */\n  overflow: auto; /* Enable scroll if needed */\n  background-color: rgb(0,0,0); /* Fallback color */\n  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n}\n.modal-content {\n  background-color: #fefefe00;\n  margin: auto;\n  padding: 20px;\n  width: 50%;\n  text-align: center;\n  user-select: none;\n}\n/* .modal-close {\n  color: #aaaaaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.modal-close:hover,\n.modal-close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n} */\n\n.loader {\n  width: 100%;\n  height: 15px;\n  text-align: center;\n}\n\n.dot {\n  position: relative;\n  width: 15px;\n  height: 15px;\n  margin: 0 2px;\n  display: inline-block;\n}\n\n.dot:first-child:before {\n  animation-delay: 0ms;\n}\n\n.dot:first-child:after {\n  animation-delay: 0ms;\n}\n\n.dot:last-child:before {\n  animation-delay: 200ms;\n}\n\n.dot:last-child:after {\n  animation-delay: 200ms;\n}\n\n.dot:before{\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 15px;\n  height: 15px;\n  background-color: blue;\n  animation-name: dotHover;\n  animation-duration: 900ms;\n  animation-timing-function: cubic-bezier(.82,0,.26,1);\n  animation-iteration-count: infinite;\n  animation-delay: 100ms;\n  background: white;\n  border-radius: 100%;  \n}\n\n.dot:after {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  background: black;\n  box-shadow: 0px 0px 1px black;\n  opacity: .20;\n  width: 100%;\n  height: 3px;\n  left: 0;\n  bottom: -2px;\n  border-radius: 100%;\n  animation-name: dotShadow;\n  animation-duration: 900ms;\n  animation-timing-function: cubic-bezier(.82,0,.26,1);\n  animation-iteration-count: infinite;\n  animation-delay: 100ms;\n}\n\n@keyframes dotShadow {\n  0% {\n    transform: scaleX(1);\n  }\n  50% {\n    opacity: 0;\n    transform: scaleX(.6);\n  }\n  100% {\n    transform: scaleX(1);\n  }\n}\n\n@keyframes dotHover {\n  0% {\n    top: 0px;\n  }\n  50% {\n    top: -50px;\n    transform: scale(1.1);\n  }\n  100% {\n    top: 0;\n  }\n}\n\n.dg {\n  padding: 3%;\n  position: absolute;\n  font-size: large;\n}\n\n/* Hide settings */\n.dg .main {\n  display: block;\n}\n\n.dg .cr.boolean,\n.dg .cr.string,\n.dg .cr.function,\n.dg.ac .close-button.close-bottom\n{\n  background-color: #aaaaaa22;\n  border-left: 0px;\n  border-bottom: 0px;\n}\n.dg .cr.string input:hover {\n  background-color: #00000000;\n  border: 1px solid #ffffffff;\n  border-radius: 4px;\n}\n.dg .cr.string input:focus {\n  background-color: #00000000;\n}\n.dg .cr.string input {\n  background-color: #00000000;\n  border: 1px solid #ffffff22;\n  border-radius: 4px;\n}\n\n.dg .close-button {\n  display: none;\n}\n\n.custom-prompt-gui {\n  position: absolute;\n  bottom: 25%;\n  left: 35%;\n  float: none;\n  top: unset;\n}\n\n.prompt {\n  position: fixed;\n  bottom: 25%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n}\n\n.prompt-input, textarea {\n  background-color : #ffffff44;\n  font-size: 5em;\n  border-radius: 0.25em;\n  outline: none;\n  border: 2px solid #aaaaaa99;\n  text-align: center;\n  backdrop-filter: blur(2px);\n  width: 70vw;\n}\n\n/* :root {\n  --tp-font-family: Courier;\n} */\n\n:root {\n  --tp-blade-value-width: 55vw;\n}\n\n:root {\n  --tp-base-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  --tp-container-foreground-color: #fff;\n  --tp-label-foreground-color: #fff;\n  --tp-container-unit-size: 28px;\n  --tp-button-background-color: rgba(0,0,0, .3);\n  --tp-button-foreground-color: #fff;\n  --tp-input-background-color:  rgba(0,0,0, .3);\n  --tp-input-foreground-color: #fff;\n  --tp-button-background-color-active: rgba(0,0,0, .3);\n  --tp-button-background-color-focus: rgba(0,0,0, .3);\n  --tp-button-background-color-hover: rgba(0,0,0, .3) ;\n  --tp-base-background-color: rgb(40 41 46 / .6);\n  --tp-container-background-color: rgba(187, 188, 196, 0.1);\n}\n\n[data-theme=\"light\"] {\n  --tp-container-foreground-color: #000;\n  --tp-label-foreground-color: #000;\n  --tp-button-background-color: rgba(165,165,165, .3);\n  --tp-button-foreground-color: #000;\n  --tp-input-background-color:  rgba(255,255,255, .3);\n  --tp-input-foreground-color: #000;\n  --tp-button-background-color-active: rgba(255,255,255, .3);\n  --tp-button-background-color-focus: rgba(255,255,255, .3);\n  --tp-button-background-color-hover: rgba(255,255,255, .3) ;\n  --tp-base-background-color: rgba(249, 249, 249, 0.6);\n  --tp-container-background-color: rgba(65, 65, 65, 0.1);\n}\n\n[data-theme=\"dark\"] {\n  --tp-container-foreground-color: #fff;\n  --tp-label-foreground-color: #fff;\n  --tp-button-background-color: rgba(0,0,0, .3);\n  --tp-button-foreground-color: #fff;\n  --tp-input-background-color:  rgba(0,0,0, .3);\n  --tp-input-foreground-color: #fff;\n  --tp-button-background-color-active: rgba(0,0,0, .3);\n  --tp-button-background-color-focus: rgba(0,0,0, .3);\n  --tp-button-background-color-hover: rgba(0,0,0, .3) ;\n  --tp-base-background-color: rgb(40 41 46 / .6);\n  --tp-container-background-color: rgb(32 32 32 / 20%);\n}\n\ndiv.tp-dfwv {\n  width: 90vw;\n  top: 60%;\n  left: 50%;\n  transform: translateX(-50%);\n\n  @supports (-webkit-touch-callout: none) {\n      /* CSS specific to iOS devices */ \n      position: fixed;\n  }\n    \n    @supports not (-webkit-touch-callout: none) {\n      /* CSS for other than iOS devices */ \n      position: absolute;\n  }\n}\n\ndiv.tp-tabv_c {\n  overflow: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgb(40, 40, 40, 0.5) rgba(40,41,46, 0.1);\n  max-height: 20vh;\n}\ndiv.tp-tabv_c::-webkit-scrollbar {\n  width: 12px;               /* width of the entire scrollbar */\n}\n\ndiv.tp-tabv_c::-webkit-scrollbar-track {\n  background: rgba(40,41,46, 0.1);        /* color of the tracking area */\n}\n\ndiv.tp-tabv_c::-webkit-scrollbar-thumb {\n  background-color: rgb(40, 40, 40, 0.5);    /* color of the scroll thumb */\n  border-radius: 20px;       /* roundness of the scroll thumb */\n  border: 3px solid rgba(40,41,46, 0.1);  /* creates padding around scroll thumb */\n}\n\ndiv.tp-rotv {\n  font-size: 1em;\n  backdrop-filter: blur(4px);\n}\n\ndiv.tp-btngridv {\n  display: inline-grid;\n  gap: 0.5em;\n  justify-self: center;\n}\n\ndiv.tp-fldv_m {\n  display: none;\n}\n\ndiv.btn-icon-style {\n  padding: 0 .5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.tp-btnv_b {\n  \n}\n\n/* div.tp-btnv_t {\n  font-weight: normal;\n  font-family: \"Font Awesome 6 Free Solid\";\n} */\n\n/* div.tp-btnv {\n  width: 25%;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
